<ng-container *ngIf="tooltipSettings?.targetSide === 'right' && tooltipText">
    <bazis-interrogation
        iconSize="compact"
        [tooltipText]="tooltipText"
        [tooltipOffset]="[8, 4]"
        [tooltipEventType]="tooltipSettings?.eventType || 'hover'"
        [tooltipPlacement]="tooltipSettings?.placement || 'bottom-end'"
        [icon]="icons.interrogation"
        [type]="interrogationType"
    ></bazis-interrogation>
</ng-container>
<button (click)="toggleList()">
    <bazis-icon
        [icon]="showList ? iconUp : iconDown"
        size="regular"
    ></bazis-icon>
</button>
